export default function validate(values) {
  let errors = {};

  if (!values.name) {
    errors.name = 'a folder name is required';
  }
  
  return errors;
};